import { Button } from "@fluentui/react-components";
import { useIntl } from "react-intl";
import { ContactLabel } from "@/components/atoms/contactLabel";
import { flattenAdvancedFilter } from "./advancedFilterUtils";
import { useStyle } from "./style";
import { ActiveFilterChipsProps } from "./types";

export const ActiveFilterChips = (
	props: ActiveFilterChipsProps
): JSX.Element | null => {
	const { value, onRemove, onClearAll } = props;
	const intl = useIntl();
	const classes = useStyle();

	const chips = flattenAdvancedFilter(value);

	if (chips.length === 0) {
		return null;
	}

	return (
		<div className={classes.chips}>
			{chips.map((chip) => (
				<ContactLabel
					key={`${chip.key}-${chip.value.value}`}
					text={chip.value.label}
					appearance={undefined}
					buttonAriaLabel={intl.formatMessage(
						{ id: "Contacts.AdvancedFilter.RemoveValue" },
						{ value: chip.value.label }
					)}
					onButtonClick={() => onRemove(chip.key, chip.value.value)}
				/>
			))}
			<Button appearance="transparent" onClick={onClearAll}>
				{intl.formatMessage({ id: "Contacts.AdvancedFilter.ClearAll" })}
			</Button>
		</div>
	);
};
